import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
const DocTable = ({ headers, data, colSpan }) => {
  return headers && data ? (
    <View style={tableStyles.table} wrap={false}>
      <View style={tableStyles.tableRow}>
        {headers.map((e, i) => (
          <View
            style={[
              tableStyles.tableCol,
              {
                flex:
                  colSpan && colSpan.length === headers.length ? colSpan[i] : 1,
              },
            ]}
            key={e}
          >
            <Text style={[tableStyles.tableCell, tableStyles.headerCell]}>
              {e}
            </Text>
          </View>
        ))}
      </View>
      {data.length > 0 ? (
        data.map((obj) => (
          <View style={tableStyles.tableRow} key={JSON.stringify(obj)}>
            {headers.map((key, i) => (
              <View
                style={[
                  tableStyles.tableCol,
                  {
                    flex:
                      colSpan && colSpan.length === headers.length
                        ? colSpan[i]
                        : 1,
                  },
                ]}
                key={key}
              >
                <Text style={[tableStyles.tableCell]}>{obj[key]}</Text>
              </View>
            ))}
          </View>
        ))
      ) : (
        <View style={tableStyles.tableRow}>
          <View
            style={[
              tableStyles.tableCol,
              {
                flex: headers.length,
              },
            ]}
          >
            <Text style={[tableStyles.tableCell, { textAlign: "center" }]}>
              {" "}
              No Data{" "}
            </Text>
          </View>
        </View>
      )}
    </View>
  ) : (
    <Text> No data</Text>
  );
};

const tableStyles = StyleSheet.create({
  // table
  table: {
    display: "table",
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    flexDirection: "col",
  },
  tableRow: {
    flexDirection: "row",
  },
  tableCol: {
    // flex: 1,
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCell: {
    margin: 5,
    fontSize: 12,
  },
  headerCell: {
    fontFamily: "Helvetica-Bold",
  },
});

export default DocTable;
